import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';
import {
  GUILD_DENSITIES,
  GUILD_CULTURES,
  GUILD_VOLATILITIES,
  defaultOptionValue
} from '../../../constants/global-context.constants';

@Component({
    selector: 'app-global-context-step-4',
    templateUrl: './global-context-step-4.component.html',
    styleUrls: ['./global-context-step-4.component.scss'],
    standalone: false
})
export class GlobalContextStep4Component implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  densities = GUILD_DENSITIES;
  cultures = GUILD_CULTURES;
  volatilities = GUILD_VOLATILITIES;

  mapName = '';

  // Form Fields
  prominentGuilds = '';
  selectedDensity = defaultOptionValue(this.densities);
  selectedCulture = defaultOptionValue(this.cultures);
  selectedVolatility = defaultOptionValue(this.volatilities);

  // Validation
  showErrorMsg = false;
  validationErrorText = '';

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';

      // Restore values from state if they exist
      if (state.globalContext) {
        const gc = state.globalContext;
        this.prominentGuilds = gc.prominentGuilds || '';
        this.selectedDensity = gc.guildDensity || defaultOptionValue(this.densities);
        this.selectedCulture = gc.guildCulture || defaultOptionValue(this.cultures);
        this.selectedVolatility = gc.guildVolatility || defaultOptionValue(this.volatilities);
      }
      this.cdr.detectChanges();
    });
  }

  onNext(): void {
    this.showErrorMsg = false;
    this.validationErrorText = '';

    // Validate fields
    if (!this.prominentGuilds.trim()) {
      this.validationErrorText = 'Prominent Guilds is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedDensity) {
      this.validationErrorText = 'Guild Density is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedCulture) {
      this.validationErrorText = 'Guild Culture is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedVolatility) {
      this.validationErrorText = 'Guild Volatility is required.';
      this.showErrorMsg = true;
      return;
    }

    // Save state
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        prominentGuilds: this.prominentGuilds,
        guildDensity: this.selectedDensity,
        guildCulture: this.selectedCulture,
        guildVolatility: this.selectedVolatility
      }
    });

    this.next.emit();
  }

  onBack(): void {
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        prominentGuilds: this.prominentGuilds,
        guildDensity: this.selectedDensity,
        guildCulture: this.selectedCulture,
        guildVolatility: this.selectedVolatility
      }
    });
    this.back.emit();
  }
}
